import React, { 
    Component, 
    useEffect, 
    useState 
} from 'react';
import { 
    withTranslation, 
    Trans, 
    withNamespaces 
} from 'react-i18next';
// import { withStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';


const CustomToaster = ({ data, headContent, alertType, listId, sId, lang }) => {

  const [selectProductId, setSelectProductId] = useState(null);

  useEffect(() => {
    setSelectProductId(setSelectProductId);
  },[sId]);

  const renderBtn = () => {
    if(alertType == 'add' || alertType == 'rmv'){
      return(
        <button className="blue-btn" onClick={() => goToExpress()}><Trans>Checkout</Trans></button>
      );
    }
    
    if(alertType == 'lst' && listId){
      return(
        <button className="blue-btn" onClick={() => goToList()}><Trans>Show the list</Trans></button>
      );
    }
    
    if(alertType == 'fev'){
      return(
        <button className="blue-btn" onClick={() => goToFev()}><Trans>Goto fevorite list</Trans></button>
      );
    }
  }

    //remove all characters except a-z0-9 
  const manufacturerFilter= (manufacturer) => {
      let filtered = manufacturer.replace(/[^a-z0-9]/gi, '');   
      // return filtered replacing characters to lowercase    
      return filtered.toLowerCase(); 
  }

  const goToExpress = () => {
    let newurl = window.location.protocol + "//" + window.location.host + "/" + "cart.php";
    window.location.href = newurl
  }
  
  const goToList = () => {
    let newurl = window.location.protocol + "//" + window.location.host + "/" + "templateView.php?document_id="+listId;
    window.location.href = newurl
  }
  
  const goToFev = () => {
    let newurl = window.location.protocol + "//" + window.location.host + "/" + "favorite.php";
    window.location.href = newurl
  }

  return(
    <div className="toast-notification" >
      <div 
        className="toast-card" 
        data-target={`toast-${data.id.raw}`} 
        // style={selectProductId == data.id.raw ? { display: 'block' } : { display: 'none' }}
        style={{ display: 'block' }}
      >
        <div className="toast-progress">
          <span></span>
        </div>
        <div className="toast-heading">
          <p className="fh4" style={{color: 'black'}}><Trans>{headContent}</Trans></p>
        </div>
        {alertType != 'lstn' ? 
          <div className="toast-content box-shadow-strip-wrapper">
            <div className="image-block">
              <img 
              /*src={JSON.parse(data.product_data.raw).photo} */
              src={'/common/fotos/'+manufacturerFilter(data.manufacturer.raw)+'/'+manufacturerFilter(data.ref1.raw)+'.jpg'}
              alt={(data.autonames?.raw != '' ? JSON.parse(data.autonames.raw)[lang] : JSON.parse(data.product_data.raw).names[lang])}
                onError={(e) => { e.target.onerror = null; e.target.src = "/common/fotos/default.png" }}
              />
              {/*<img src="images/order-item.jpg"  />*/}
            </div>
            <div className="content-block">
              <p><a href={`/producto.php?cod_producto=${data.id.raw}`} title={(data.autonames?.raw != '' ? JSON.parse(data.autonames.raw)[lang] : JSON.parse(data.product_data.raw).names[lang])}>{(data.autonames?.raw != '' ? JSON.parse(data.autonames.raw)[lang] : JSON.parse(data.product_data.raw).names[lang])}</a></p>
              { renderBtn() }
            </div>
          </div>
        :""}
        {alertType != 'lst' && alertType != 'lstn' && alertType != 'fev' ?
          <div className="toast-footer">
            <p><Trans>Some units on request from the manufacturer</Trans></p>
          </div>
        : ""}
      </div>
    </div>
  );

}

export default withTranslation()(CustomToaster);